module.exports = __webpack_public_path__ + "media/images/sp/top/icon-station_re-bc2d47afa9471abf98f52fb4aff37be9.png";